import { render, staticRenderFns } from "./FavoritesClearComponent.vue?vue&type=template&id=09997713"
import script from "./FavoritesClearComponent.vue?vue&type=script&lang=js"
export * from "./FavoritesClearComponent.vue?vue&type=script&lang=js"
import style0 from "./FavoritesClearComponent.vue?vue&type=style&index=0&id=09997713&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports